export const SAVE_CUSTOMER_INFO_REQUEST = "SAVE_CUSTOMER_INFO_REQUEST";
export const SAVE_CUSTOMER_INFO_SUCCESS = "SAVE_CUSTOMER_INFO_SUCCESS";
export const CLEAN_CUSTOMER_INFO_REQUEST = "CLEAN_CUSTOMER_INFO_REQUEST";